// @ts-nocheck

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonUI, useDidUpdate } from 'sonata-react-components';

import { reportingDownloadInsightsData } from '@/store/actions/reporting.actions';
import { getDownloadInsightsData } from '@/store/selectors/reporting.selectors';
import './reportingInsightsDownload.scss';

function ReportingInsightsDownload({ insightsConfig, metricsKpis, section }) {
  const dispatch = useDispatch();
  const downloadInsightsData = useSelector(getDownloadInsightsData);
  const downloadInsightsDataToken = {};

  const [{ downloadInsightsLoading }, setState] = useState({
    downloadInsightsLoading: downloadInsightsData.status !== 'finished'
  });

  useEffect(() => {
    return () => {
      downloadInsightsDataToken?.cancel && downloadInsightsDataToken.cancel();
    };
  }, []);

  useDidUpdate(() => {
    setState(prevState => ({
      ...prevState,
      downloadInsightsLoading: downloadInsightsData.status !== 'finished'
    }));
    if (downloadInsightsData.status === 'finished' && !isEmpty(downloadInsightsData.result)) {
      window.open(downloadInsightsData.result.urlFile);
    }
  }, [downloadInsightsData]);

  const downloadInsightsReport = useCallback(() => {
    dispatch(
      reportingDownloadInsightsData(
        insightsConfig,
        {
          kpi: metricsKpis.kpi?.id,
          kpiCpy: metricsKpis.kpi?.label,
          metric: metricsKpis.metric.id,
          metricCpy: metricsKpis.metric.label
        },
        downloadInsightsDataToken,
        section
      )
    );
  }, [downloadInsightsDataToken, insightsConfig, metricsKpis, section]);

  return (
    <div className="reportingInsights__downloadContainer">
      <ButtonUI
        className="reportingInsights__downloadButton"
        icon="fas fa-arrow-to-bottom"
        id="download-insights"
        loading={downloadInsightsLoading}
        onClick={downloadInsightsReport}
        size="medium"
      />
    </div>
  );
}

ReportingInsightsDownload.propTypes = {
  insightsConfig: PropTypes.array.isRequired,
  metricsKpis: PropTypes.shape({
    kpi: PropTypes.object,
    metric: PropTypes.object.isRequired
  }).isRequired,
  section: PropTypes.string
};

export default React.memo(ReportingInsightsDownload);
